/* Version: 3.5.149 */
'use client';
import styled from 'styled-components';
import brandingColors from '../../colors/colors.js';
import { SUB_NAV_WIDTH, MAIN_NAV_WIDTH_WIDE, MAIN_NAV_WIDTH, SUB_NAV_WIDTH_XL } from '../SideNav/styledComponents.js';
import { BREAKPOINTS } from '../../spacing/index.js';

var HEADER_HEIGHT = '40px';
var MainWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__MainWrapper",
  componentId: "sc-sbvs6f-0"
})(["display:flex;flex-direction:row;flex-grow:1;min-height:calc(100vh - ", ");position:relative;overflow-x:clip;@media (max-width:", "px){min-height:100vh;}"], HEADER_HEIGHT, BREAKPOINTS.MAX_1024);
var MainContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__MainContainer",
  componentId: "sc-sbvs6f-1"
})(["--mux-SideNav-SubNav-width:", ";display:flex;flex-direction:column;flex-grow:0;margin-left:", ";transform:", ";transition:all 0.1s ease-in-out;width:", ";@media (max-width:", "px){margin:60px 0 0;width:100%;}@media (min-width:", "px){--mux-SideNav-SubNav-width:", ";}"], function (_ref) {
  var _theme$sideNav;
  var theme = _ref.theme;
  return (theme === null || theme === undefined || (_theme$sideNav = theme.sideNav) === null || _theme$sideNav === undefined || (_theme$sideNav = _theme$sideNav.subNav) === null || _theme$sideNav === undefined ? undefined : _theme$sideNav.width) || SUB_NAV_WIDTH;
}, function (_ref2) {
  var isWide = _ref2.isWide;
  return isWide ? MAIN_NAV_WIDTH_WIDE : MAIN_NAV_WIDTH;
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return "translateX(".concat(isExpanded ? 'var(--mux-SideNav-SubNav-width)' : '0', ")");
}, function (_ref4) {
  var isExpanded = _ref4.isExpanded,
    isStatic = _ref4.isStatic;
  return isStatic && isExpanded ? "calc(100% - var(--mux-SideNav-SubNav-width) - ".concat(MAIN_NAV_WIDTH, ")") : "calc(100% - ".concat(MAIN_NAV_WIDTH, ")");
}, BREAKPOINTS.MAX_1024, BREAKPOINTS.DESKTOP_XL, function (_ref5) {
  var _theme$sideNav2;
  var theme = _ref5.theme;
  return (theme === null || theme === undefined || (_theme$sideNav2 = theme.sideNav) === null || _theme$sideNav2 === undefined || (_theme$sideNav2 = _theme$sideNav2.subNav) === null || _theme$sideNav2 === undefined ? undefined : _theme$sideNav2.width) || SUB_NAV_WIDTH_XL;
});
var MainContent = /*#__PURE__*/styled.main.withConfig({
  displayName: "styledComponents__MainContent",
  componentId: "sc-sbvs6f-2"
})(["background-color:", ";flex-basis:auto;flex-grow:1;flex-shrink:0;"], brandingColors.light_2_grey);
var SideNavWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SideNavWrapper",
  componentId: "sc-sbvs6f-3"
})(["& > nav{top:0;}"]);
var ConnectedWrapper = /*#__PURE__*/styled(MainWrapper).withConfig({
  displayName: "styledComponents__ConnectedWrapper",
  componentId: "sc-sbvs6f-4"
})(["flex-direction:column;min-height:100vh;& ", "{flex-grow:1;}"], MainContainer);

export { ConnectedWrapper, MainContainer, MainContent, MainWrapper, SideNavWrapper };
